




























































import { Vue, Component, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  computed: {
    ...mapGetters({
      currentOauthClient: "auth/client/currentOauthClient",
      defaultOauthClient: "auth/client/defaultOauthClient",
      isSupportedOauthClient: "auth/client/isSupportedOauthClient",
      defaultOauthClientRedirect: "auth/client/defaultOauthClientRedirect",
      isClientAuthenticated: "auth/client/isAuthenticated",
      isGuestAuthenticated: "auth/guest/isAuthenticated"
    })
  },
  components: {
    "basket-provider": () =>
      import("@/components/app/global/baskets/basket/basketProvider.vue"),
    "basket-provisioning-provider": () =>
      import("@/components/app/global/baskets/basket/provisioningProvider.vue"),
    "shop-provider": () =>
      import("@/components/app/global/baskets/basket/shopProvider.vue")
  }
})
export default class OrderView extends Vue {
  // Map getters

  public isClientAuthenticated!: boolean;
  public isGuestAuthenticated!: boolean;
  public isSupportedOauthClient!: boolean;
  public currentOauthClient!: string;
  public defaultOauthClientRedirect!: string;

  // Props

  @Prop({ default: "" })
  public routeClientId!: string | number;

  @Prop({ default: "" })
  public routeAccountId!: string | number;

  @Prop({ default: "" })
  public routeBasketId!: string | number;

  @Prop({ default: "" })
  public routeOrderId!: string | number;

  @Prop({ default: 0 })
  public billingTerm!: number;

  @Prop({ default: 1 })
  public quantity!: number;

  @Prop({ default: "" })
  public routeCurrencyCode!: string;

  @Prop({ default: "" })
  public routeCoupons!: string;

  @Prop({ default: false })
  public routeCrossSell!: boolean;

  @Prop({ default: false })
  public routeReadMore!: boolean;

  // Variables

  public isLoading = true;

  // Life cycle methods

  public async created() {
    if (this.isSupportedOauthClient) {
      if (this.isClientAuthenticated || this.isGuestAuthenticated) {
        this.isLoading = false;
        return;
      }

      await this.$store.dispatch("auth/guest/createToken");
      this.isLoading = false;
    }
  }
}
